import {
  Button,
  Col,
  Input,
  Modal,
  QRCode,
  Row,
  Select,
  Switch,
  Typography,
} from "antd";
import "./editUserModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { GetReportFilterReq } from "../../interfaces/event.interface";
import { newReportService } from "../../services/report.service";
import {
  AdminCreateUserReq,
  AdminGetUserRes,
  AdminUpdateUserReq,
} from "../../interfaces/user.interface";
import { GetRoleRes } from "../../interfaces/role.interface";
import { getRolesService } from "../../services/role.service";
import {
  adminChangeUserPasswordService,
  adminCreateUserService,
  adminUpdateUserService,
} from "../../services/user.service";
import PasswordStrengthBar from "react-password-strength-bar";


interface Props {
  show: boolean;
  onClose: () => void;
  user: AdminGetUserRes;
}

export const EditUserModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState<AdminGetUserRes>({
    id: 0,
    email: "",
    email_verified: true,
    first_name: "",
    last_name: "",
    username: "",
    roles: [],
    totp_enable: false,
  });

  const [password, setPassword] = useState("");
  const [retryPassword, setRetryPassword] = useState("");

  const [isPasswordStrong, setIsPasswordStrong] = useState(false);

  const [roles, setRoles] = useState<GetRoleRes[]>([]);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    setUser(props.user);
  }, [props.user]);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      const res = await getRolesService({});
      setRoles(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {
      if (
        !user.first_name ||
        !user.last_name ||
        !user.username ||
        user.roles.length == 0 ||
        !password ||
        !retryPassword
      ) {
        toast.error("مقادیر اجباری را وارد کنید");
        return;
      }

      

      if (password != "" && password != retryPassword) {
        toast.error("رمز عبور و تکرار رمز عبور یکسان نیست");
        setLoading(false);
        return;
      }

      if(!isPasswordStrong){
          toast.error("رمز عبور ضعیف است")
          return
        }

        setLoading(true);

      const res = await adminUpdateUserService({
        email: user.email,
        email_verified: user.email_verified,
        first_name: user.first_name,
        id: user.id,
        last_name: user.last_name,
        roles: user.roles,
        totp_enable: user.totp_enable,
      });

      if (password != "" && password === retryPassword) {
        const res = await adminChangeUserPasswordService({
          new_password: password,
          retry_new_password: retryPassword,
          user_id: user.id,
        });
      }

      setPassword("");
      setRetryPassword("");
      setUser({
        id: 0,
        email: "",
        email_verified: true,
        first_name: "",
        last_name: "",
        username: "",
        roles: [],
        totp_enable: false,
      });

      setLoading(false);
      props.onClose();
      setShow(false);
      toast.success("اطلاعات کاربر با موفقیت ویرایش شد");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="EditUserModal">
      <Modal
        destroyOnClose={true}
        title={"افزودن کاربر جدید"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setPassword("");
          setRetryPassword("");
          setUser({
            id: 0,
            email: "",
            email_verified: true,
            first_name: "",
            last_name: "",
            username: "",
            roles: [],
            totp_enable: false,
          });
          setLoading(false);
        }}
        open={show}
        footer={null}
        width={650}
      >
        <div className="EditUserModalContent">
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>نام:{" "}
              </Typography.Text>
              <Input
                className="input"
                value={user.first_name}
                onChange={(e) => {
                  setUser({
                    ...user,
                    first_name: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>
                نام خانوادگی:
              </Typography.Text>
              <Input
                className="input"
                value={user.last_name}
                onChange={(e) => {
                  setUser({
                    ...user,
                    last_name: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>نام کاربری:{" "}
              </Typography.Text>
              <Input
                className="input"
                value={user.username}
                disabled
                onChange={(e) => {
                  setUser({
                    ...user,
                    username: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">ایمیل: </Typography.Text>
              <Input
                className="input"
                value={user.email}
                onChange={(e) => {
                  setUser({
                    ...user,
                    email: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>نقش کاربری:{" "}
              </Typography.Text>
              <Select
                mode="multiple"
                variant="filled"
                size="large"
                options={roles.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })}
                value={user.roles}
                onChange={(e) => {
                  setUser({
                    ...user,
                    roles: e,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>رمز عبور:{" "}
              </Typography.Text>
              <Input.Password
                className="input"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <PasswordStrengthBar
                scoreWords={["ضعیف", "ضعیف", "متوسط", "خوب", "قوی"]}
                shortScoreWord={"خیلی ضعیف"}
                password={password}
                onChangeScore={(e)=>{
                  if(e >= 3){
                    setIsPasswordStrong(true)
                  }else{
                    setIsPasswordStrong(false)
                  }
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>
                تکرار رمز عبور:
              </Typography.Text>
              <Input.Password
                className="input"
                value={retryPassword}
                onChange={(e) => {
                  setRetryPassword(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row
            justify={"space-between"}
            style={{
              marginTop: 5,
              marginBottom: 5,
            }}
          >
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                ورود دومرحله‌ای{" "}
              </Typography.Text>
              <Switch
                disabled={!user.totp_enable}
                checked={user.totp_enable}
                onChange={(e) => {
                  console.log(e);
                  setUser({
                    ...user,
                    totp_enable: e,
                  });
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                بروزرسانی
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
